<template>
  <div id="grid-asigancion-data">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              v-if="
                tipeView == 'consulta' || usuarioLoggedTipe == 'AGENCIA'
                  ? false
                  : true
              "
              title="Nueva"
              @click="openNew()"
              >Nuevo</v-btn
            >
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="itemsAsignacion"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">
                {{ props.item.salCursos.nombreStab }}
              </td>
              <td class="text-xs-left">
                {{ props.item.salCursos.codigoCurso }}
              </td>
              <td class="text-xs-left">{{ props.item.salCursos.nivel }}</td>
              <td class="text-xs-left">{{ props.item.salCursos.letra }}</td>
              <td class="text-xs-left">{{ props.item.salCursos.rbd }}</td>
              <td class="text-xs-left">
                {{
                  props.item.supervisorId.rut + "-" + props.item.supervisorId.dv
                }}
              </td>
              <td>
                <v-btn
                  v-if="
                    tipeView == 'consulta' || usuarioLoggedTipe == 'AGENCIA'
                      ? false
                      : true
                  "
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Editar asignacion"
                  @click="
                    openAsignaciones(
                      props.item.id,
                      props.item.salCursos.codigoCurso,
                      props.item.salCursos.nivel,
                      props.item.salCursos.letra,
                      props.item.salCursos.rbd,
                      props.item.supervisorId.rut,
                      props.item.supervisorId.dv
                    )
                  "
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA USUARIO -->
          <v-card-actions
            v-if="
              tipeView == 'consulta' || usuarioLoggedTipe == 'AGENCIA'
                ? false
                : true
            "
            class="pb-3"
          >
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="primary"
              small
            >
              <v-icon>open_in_new</v-icon> </v-btn
            >Editar asignacion
          </v-card-actions>
        </v-flex>
      </v-layout>
      <!-- dialogo    -->
      <v-dialog v-model="dialogAsig" persistent max-width="590">
        <v-card>
          <v-card-title class="headline">Asignación</v-card-title>
          <v-card-text>Crear o editar Asignación</v-card-text>
          <v-container>
            <v-flex xs12 md6>
              <v-text-field
                v-if="tipeView == 'oculto'"
                v-model="rutCandidatoValue"
                label="Rut Reclutado"
                counter="10"
                maxlength="10"
              ></v-text-field>
            </v-flex>

            <v-layout>
              <v-flex xs12 md4>
                <v-sheet>
                  <v-switch
                    v-model="switch1"
                    color="indigo darken-3"
                    inset
                    :label="`Examinador Adicional`"
                  ></v-switch>
                </v-sheet>
              </v-flex>
              <v-flex xs12 md1></v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="cursoValue"
                  label="Curso"
                  item-text="nombre"
                  item-value="code"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md1></v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="rbdValue"
                  label="Rbd"
                  item-text="nombre"
                  item-value="code"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="nivelValue"
                  label="Nivel"
                  :items="nivelSelect"
                  item-text="nombre"
                  item-value="code"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md1></v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="letraValue"
                  label="Letra"
                  item-text="nombre"
                  item-value="code"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="rutSupervisorValue"
                  label="Rut Supervisor"
                  counter="10"
                  maxlength="10"
                  item-text="nombre"
                  item-value="code"
                  @input="dvRut()"
                  @focusout="checkRut"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialogAsig = false"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" flat @click="closeModal()"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogo -->
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import { misMixins } from "@/mixins/myMixing.js";
import Loading from "@/views/ui/Loading.vue";
export default {
  name: "grid-asigancion-data",
  components: {
    Loading,
  },
  props: {
    tipeView: "",
    id: "",
    rut: "",
  },
  mixins: [misMixins],
  data() {
    return {
      loading: false,
      dialogAsig: false,
      switch1: false,
      nivelSelect: [],
      rutSupervisorValue: "",
      establecimientoValue: "",
      rutCandidatoValue: "",
      cursoValue: "",
      nivelValue: "",
      letraValue: "",
      rbdValue: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      contratoId: "",
      itemsAsignacion: [],
      headers: [
        { text: "Establecimiento", sortable: false, value: "establecimiento" },
        { text: "Curso", sortable: false, value: "curso" },
        { text: "Nivel", sortable: false, value: "nivel" },
        { text: "Letra", sortable: false, value: "letra" },
        { text: "RBD", sortable: false, value: "rbd" },
        { text: "Supervisor", sortable: false, value: "rutsupervisor" },
        {
          text: "Accion",
          sortable: false,
          value: "",
        },
      ],
    };
  },
  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.contratoId = this.$store.getters.contratoStored;
    this.id = this.$route.params.id;
    this.rut;
    //this.rut = this.$route.params.rut;
    console.log(this.rut);
    this.loadDataAsignacion();
  },

  mounted() {
    if (
      this.contratoId != null &&
      this.contratoId != "" &&
      this.contratoId !== undefined
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    }

    this.proceso = this.$store.getters.subProTabSelectedStored;
  },
  computed: {},
  methods: {
    async loadDataAsignacion() {
      this.loading = true;
      this.itemsAsignacion = await this.loadAsignacion();
      this.loading = false;
    },
    loadRutCandidato() {
      let rca = [];
      this.itemsAsignacion.forEach(function (d) {
        let index = rca.findIndex((x) => x.candidato == d.candidato.rut);
        if (index === -1) {
          if (d.candidato.rut != null && d.candidato.rut != "") {
            rca.push(d.candidato.rut + "-" + d.candidato.dv);
          }
        }
      });
      this.rutCandidatoValue = rca;
    },

    async loadAsignacion() {
      let idCandidato = this.id;
      return await axios
        .get("/candidatos/asignacion/" + idCandidato + "/" + this.contratoId)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    dvRut() {
      let f = this.formateaRut(this.rutSupervisorValue);
      if (f == undefined) {
        this.rutSupervisorValue = this.rutSupervisorValue;
      } else {
        this.rutSupervisorValue = f;
      }
    },
    checkRut() {
      let v = this.validaRut(this.rutSupervisorValue);

      if (v === false) {
        return console.log("false");
      } else {
        //esto es para hacer algun tipo de validacion
        this.dv = obtenerDv(this.rutSupervisorValue);
        return console.log("verdadero");
      }
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },
    closeModal() {
      if (this.asignacionId == undefined) {
        this.newAsignacion();
        //    this.dialogAsig = false;
        //    this.loadDataAsignacion();
        //    this.reload();
      } else {
        this.editAsignaciones();
        /*   this.dialogAsig = false;
           this.loadDataAsignacion();
           this.reload(); */
      }

      this.dialogAsig = false;
      this.loadDataAsignacion();
      this.reload();
    },
    openAsignaciones(id, codigoCurso, nivel, letra, rbd, rut, dv) {
      this.dialogAsig = true;
      this.asignacionId = id;
      this.cursoValue = codigoCurso;
      this.nivelValue = nivel;
      this.letraValue = letra;
      this.rbdValue = rbd;
      this.rutSupervisorValue = rut + "-" + dv;
    },
    openNew() {
      this.dialogAsig = true;
      this.nivelValue = "";
      this.cursoValue = "";
      this.letraValue = "";
      this.rbdValue = "";
      this.rutSupervisorValue = "";
      // this.loadRutCandidato();
    },

    editAsignaciones() {
      let idContrato = this.$store.getters.contratoStored;
      let id = this.id;
      let dv = this.obtenerDv(this.rutSupervisorValue);
      let rut = this.obtenerSoloRut(this.rutSupervisorValue);
      let v = this.validaRut(this.rutSupervisorValue);
      this.body = {
        contratoId: idContrato,
        examinadorAdicional: this.switch1,
        curso: this.cursoValue,
        nivel: this.nivelValue,
        rbd: this.rbdValue,
        letra: this.letraValue,
        rut_sup: rut,
        dv_rut_sup: dv,
      };

      axios
        .put("candidatos/asignacion/update/" + this.asignacionId, this.body)
        .then((response) => {
          this.resp = response.data;
          console.log(response.data);
          window.getApp.$emit("APP_SAVE");
          this.dialogAsig = false;
          this.reload();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
        });
    },
    newAsignacion() {
      let idContrato = this.$store.getters.contratoStored;
      let id = this.id;
      let rutcan = this.rut;
      let dv = this.obtenerDv(this.rutSupervisorValue);
      let rut = this.obtenerSoloRut(this.rutSupervisorValue);
      let dvExa = this.obtenerDv(this.rut);
      let rutExa = this.obtenerSoloRut(this.rut);
      let v = this.validaRut(this.rutSupervisorValue);
      this.body = {
        contratoId: idContrato,
        rut_exa: rutExa,
        dv_rut_exa: dvExa,
        examinadorAdicional: this.switch1,
        curso: this.cursoValue,
        nivel: this.nivelValue,
        rbd: this.rbdValue,
        letra: this.letraValue,
        rut_sup: rut,
        dv_rut_sup: dv,
      };
      axios
        .post("candidatos/asignacion/new", this.body)
        .then((response) => {
          this.resp = response.data;
          console.log(response.data);
          window.getApp.$emit("APP_SAVE");
          this.dialogAsig = false;
          this.reload();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
        });
    },
  },
};
</script>
